import React, { Component, Fragment } from "react";
import { properties } from "../constants/Propertise";
import { connect } from 'react-redux';
import { setBackgroundColorRevise, setHeaderBackgroundColourRevise, setBackgroundImageRevise } from '../Reducers/ThemeOptions';
import { api } from "../api/api";
class Theme extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    themeHandler = (id, headerTheme, sidebarTheme) => {
        let userPreferencesBody
        if (id !== null) {
            userPreferencesBody = {
                id: id,
                username: localStorage.getItem('onevuusername'),
                headerTheme: headerTheme,
                sidebarTheme: sidebarTheme
            }
        } else {
            userPreferencesBody = {
                username: localStorage.getItem('onevuusername'),
                headerTheme: headerTheme,
                sidebarTheme: sidebarTheme
            }
        }
        return userPreferencesBody
    }

    changeHeader = (headerTheme) => {
        localStorage.setItem('oneviewheaderTheme', headerTheme);
        this.props.setHeaderBackgroundColourRevise(headerTheme);
    }

    changeSideBar = (siderbarTheme) => {
        localStorage.setItem('oneviewsiderbarTheme', siderbarTheme);
        this.props.setBackgroundColorRevise(siderbarTheme);
    }

    restoreDefaultHeader = (event) => {
        event.preventDefault();
        // this.props.setHeaderBackgroundColourRevise('bg-night-sky header-text-light');

        let { headerBackgroundColor, backgroundColor } = this.props
        let userPreferencesThemeUrl = `${process.env.REACT_APP_USERMANAGEMENT_API_URL}userPreferences`;
        let userPreferencesBody = this.themeHandler(localStorage.getItem('id'), 'bg-night-sky header-text-light', backgroundColor)
        api
            .post(userPreferencesThemeUrl, userPreferencesBody)
            .then(result => {
                if (result.status === 200) {
                    localStorage.setItem('oneviewheaderTheme', 'bg-night-sky header-text-light');
                    this.props.setHeaderBackgroundColourRevise(result.data.headerTheme);
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    restoreDefaultSideBar = (event) => {
        event.preventDefault();
        // this.props.setBackgroundColorRevise('bg-royal sidebar-text-light');

        let { headerBackgroundColor, backgroundColor } = this.props
        let userPreferencesThemeUrl = `${process.env.REACT_APP_USERMANAGEMENT_API_URL}userPreferences`;
        let userPreferencesBody = this.themeHandler(localStorage.getItem('id'), headerBackgroundColor, 'bg-royal sidebar-text-light')
        api
            .post(userPreferencesThemeUrl, userPreferencesBody)
            .then(result => {
                if (result.status === 200) {
                    localStorage.setItem('oneviewsiderbarTheme', 'bg-royal sidebar-text-light');
                    this.props.setBackgroundColorRevise(result.data.sidebarTheme);
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    render() {
        return (
            <Fragment>
                <div className="mb-3">

                    <div className="form-row">
                        <div className="col-md-6">
                            <h5 className="themeoptions-heading">
                                <div>
                                    {properties.headerOptiontext}
                                </div>
                            </h5>
                        </div>
                        <div className="col-md-6 pull-right">
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-class=""
                                onClick={this.restoreDefaultHeader}
                            >
                                {properties.restoreDefaultText}
                            </button>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="p-3">
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <h6 class="pb-2">{properties.userColorScText}</h6>
                                    <div class="theme-settings-swatches">
                                        <div
                                            className="swatch-holder bg-primary switch-header-cs-class"
                                            data-class="bg-primary header-text-light"
                                            onClick={() => { this.changeHeader('bg-primary header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-secondary switch-header-cs-class"
                                            data-class="bg-secondary header-text-light"
                                            onClick={() => { this.changeHeader('bg-secondary header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-success switch-header-cs-class"
                                            data-class="bg-success header-text-dark"
                                            onClick={() => { this.changeHeader('bg-success header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-info switch-header-cs-class"
                                            data-class="bg-info header-text-dark"
                                            onClick={() => { this.changeHeader('bg-info header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-warning switch-header-cs-class"
                                            data-class="bg-warning header-text-dark"
                                            onClick={() => { this.changeHeader('bg-warning header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-danger switch-header-cs-class"
                                            data-class="bg-danger header-text-light"
                                            onClick={() => { this.changeHeader('bg-danger header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-light switch-header-cs-class"
                                            data-class="bg-light header-text-dark"
                                            onClick={() => { this.changeHeader('bg-light header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-dark switch-header-cs-class"
                                            data-class="bg-dark header-text-light"
                                            onClick={() => { this.changeHeader('bg-dark header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-focus switch-header-cs-class"
                                            data-class="bg-focus header-text-light"
                                            onClick={() => { this.changeHeader('bg-focus header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-alternate switch-header-cs-class"
                                            data-class="bg-alternate header-text-light"
                                            onClick={() => { this.changeHeader('bg-alternate header-text-light') }}
                                        ></div>
                                        <div className="divider"></div>
                                        <div
                                            className="swatch-holder bg-vicious-stance switch-header-cs-class"
                                            data-class="bg-vicious-stance header-text-light"
                                            onClick={() => { this.changeHeader('bg-vicious-stance header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-midnight-bloom switch-header-cs-class"
                                            data-class="bg-midnight-bloom header-text-light"
                                            onClick={() => { this.changeHeader('bg-midnight-bloom header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-night-sky switch-header-cs-class"
                                            data-class="bg-night-sky header-text-light"
                                            onClick={() => { this.changeHeader('bg-night-sky header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-slick-carbon switch-header-cs-class"
                                            data-class="bg-slick-carbon header-text-light"
                                            onClick={() => { this.changeHeader('bg-slick-carbon header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-asteroid switch-header-cs-class"
                                            data-class="bg-asteroid header-text-light"
                                            onClick={() => { this.changeHeader('bg-asteroid header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-royal switch-header-cs-class"
                                            data-class="bg-royal header-text-light"
                                            onClick={() => { this.changeHeader('bg-royal header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-warm-flame switch-header-cs-class"
                                            data-class="bg-warm-flame header-text-dark"
                                            onClick={() => { this.changeHeader('bg-warm-flame header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-night-fade switch-header-cs-class"
                                            data-class="bg-night-fade header-text-dark"
                                            onClick={() => { this.changeHeader('bg-night-fade header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-sunny-morning switch-header-cs-class"
                                            data-class="bg-sunny-morning header-text-dark"
                                            onClick={() => { this.changeHeader('bg-sunny-morning header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-tempting-azure switch-header-cs-class"
                                            data-class="bg-tempting-azure header-text-dark"
                                            onClick={() => { this.changeHeader('bg-tempting-azure header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-amy-crisp switch-header-cs-class"
                                            data-class="bg-amy-crisp header-text-dark"
                                            onClick={() => { this.changeHeader('bg-amy-crisp header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-heavy-rain switch-header-cs-class"
                                            data-class="bg-heavy-rain header-text-dark"
                                            onClick={() => { this.changeHeader('bg-heavy-rain header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-mean-fruit switch-header-cs-class"
                                            data-class="bg-mean-fruit header-text-dark"
                                            onClick={() => { this.changeHeader('bg-mean-fruit header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-malibu-beach switch-header-cs-class"
                                            data-class="bg-malibu-beach header-text-light"
                                            onClick={() => { this.changeHeader('bg-malibu-beach header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-deep-blue switch-header-cs-class"
                                            data-class="bg-deep-blue header-text-dark"
                                            onClick={() => { this.changeHeader('bg-deep-blue header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-ripe-malin switch-header-cs-class"
                                            data-class="bg-ripe-malin header-text-light"
                                            onClick={() => { this.changeHeader('bg-ripe-malin header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-arielle-smile switch-header-cs-class"
                                            data-class="bg-arielle-smile header-text-light"
                                            onClick={() => { this.changeHeader('bg-arielle-smile header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-plum-plate switch-header-cs-class"
                                            data-class="bg-plum-plate header-text-light"
                                            onClick={() => { this.changeHeader('bg-plum-plate header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-happy-fisher switch-header-cs-class"
                                            data-class="bg-happy-fisher header-text-dark"
                                            onClick={() => { this.changeHeader('bg-happy-fisher header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-happy-itmeo switch-header-cs-class"
                                            data-class="bg-happy-itmeo header-text-light"
                                            onClick={() => { this.changeHeader('bg-happy-itmeo header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-mixed-hopes switch-header-cs-class"
                                            data-class="bg-mixed-hopes header-text-light"
                                            onClick={() => { this.changeHeader('bg-mixed-hopes header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-strong-bliss switch-header-cs-class"
                                            data-class="bg-strong-bliss header-text-light"
                                            onClick={() => { this.changeHeader('bg-strong-bliss header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-grow-early switch-header-cs-class"
                                            data-class="bg-grow-early header-text-light"
                                            onClick={() => { this.changeHeader('bg-grow-early header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-love-kiss switch-header-cs-class"
                                            data-class="bg-love-kiss header-text-light"
                                            onClick={() => { this.changeHeader('bg-love-kiss header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-premium-dark switch-header-cs-class"
                                            data-class="bg-premium-dark header-text-light"
                                            onClick={() => { this.changeHeader('bg-premium-dark header-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-happy-green switch-header-cs-class"
                                            data-class="bg-happy-green header-text-light"
                                            onClick={() => { this.changeHeader('bg-happy-green header-text-light') }}
                                        ></div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="col-md-6">
                            <h5 className="themeoptions-heading">
                                <div>
                                    {properties.sideBarOptiontext}
                                </div>
                            </h5>
                        </div>
                        <div className="col-md-6 pull-right">
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-class=""
                                onClick={this.restoreDefaultSideBar}
                            >
                                {properties.restoreDefaultText}
                            </button>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="p-3">
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <h6 class="pb-2">{properties.userColorScText}</h6>
                                    <div className="theme-settings-swatches">
                                        <div
                                            className="swatch-holder bg-primary switch-sidebar-cs-class"
                                            data-class="bg-primary sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-primary sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-secondary switch-sidebar-cs-class"
                                            data-class="bg-secondary sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-secondary sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-success switch-sidebar-cs-class"
                                            data-class="bg-success sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-success sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-info switch-sidebar-cs-class"
                                            data-class="bg-info sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-info sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-warning switch-sidebar-cs-class"
                                            data-class="bg-warning sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-warning sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-danger switch-sidebar-cs-class"
                                            data-class="bg-danger sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-danger sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-light switch-sidebar-cs-class"
                                            data-class="bg-light sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-light sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-dark switch-sidebar-cs-class"
                                            data-class="bg-dark sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-dark sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-focus switch-sidebar-cs-class"
                                            data-class="bg-focus sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-focus sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-alternate switch-sidebar-cs-class"
                                            data-class="bg-alternate sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-alternate sidebar-text-light') }}
                                        ></div>
                                        <div class="divider"></div>
                                        <div
                                            className="swatch-holder bg-vicious-stance switch-sidebar-cs-class"
                                            data-class="bg-vicious-stance sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-vicious-stance sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-midnight-bloom switch-sidebar-cs-class"
                                            data-class="bg-midnight-bloom sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-midnight-bloom sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-night-sky switch-sidebar-cs-class"
                                            data-class="bg-night-sky sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-night-sky sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-slick-carbon switch-sidebar-cs-class"
                                            data-class="bg-slick-carbon sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-slick-carbon sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-asteroid switch-sidebar-cs-class"
                                            data-class="bg-asteroid sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-asteroid sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-royal switch-sidebar-cs-class"
                                            data-class="bg-royal sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-royal sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-warm-flame switch-sidebar-cs-class"
                                            data-class="bg-warm-flame sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-warm-flame sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-night-fade switch-sidebar-cs-class"
                                            data-class="bg-night-fade sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-night-fade sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-sunny-morning switch-sidebar-cs-class"
                                            data-class="bg-sunny-morning sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-sunny-morning sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-tempting-azure switch-sidebar-cs-class"
                                            data-class="bg-tempting-azure sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-tempting-azure sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-amy-crisp switch-sidebar-cs-class"
                                            data-class="bg-amy-crisp sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-amy-crisp sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-heavy-rain switch-sidebar-cs-class"
                                            data-class="bg-heavy-rain sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-heavy-rain sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-mean-fruit switch-sidebar-cs-class"
                                            data-class="bg-mean-fruit sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-mean-fruit sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-malibu-beach switch-sidebar-cs-class"
                                            data-class="bg-malibu-beach sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-malibu-beach sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-deep-blue switch-sidebar-cs-class"
                                            data-class="bg-deep-blue sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-deep-blue sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-ripe-malin switch-sidebar-cs-class"
                                            data-class="bg-ripe-malin sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-ripe-malin sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-arielle-smile switch-sidebar-cs-class"
                                            data-class="bg-arielle-smile sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-arielle-smile sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-plum-plate switch-sidebar-cs-class"
                                            data-class="bg-plum-plate sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-plum-plate sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-happy-fisher switch-sidebar-cs-class"
                                            data-class="bg-happy-fisher sidebar-text-dark"
                                            onClick={() => { this.changeSideBar('bg-happy-fisher sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-happy-itmeo switch-sidebar-cs-class"
                                            data-class="bg-happy-itmeo sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-happy-itmeo sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-mixed-hopes switch-sidebar-cs-class"
                                            data-class="bg-mixed-hopes sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-mixed-hopes sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-strong-bliss switch-sidebar-cs-class"
                                            data-class="bg-strong-bliss sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-strong-bliss sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-grow-early switch-sidebar-cs-class"
                                            data-class="bg-grow-early sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-grow-early sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-love-kiss switch-sidebar-cs-class"
                                            data-class="bg-love-kiss sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-love-kiss sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-premium-dark switch-sidebar-cs-class"
                                            data-class="bg-premium-dark sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-premium-dark sidebar-text-light') }}
                                        ></div>
                                        <div
                                            className="swatch-holder bg-happy-green switch-sidebar-cs-class"
                                            data-class="bg-happy-green sidebar-text-light"
                                            onClick={() => { this.changeSideBar('bg-happy-green sidebar-text-light') }}
                                        ></div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                    </div>

                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
        backgroundColor: state.ThemeOptions.backgroundColor,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setHeaderBackgroundColourRevise: (headerTheme) => dispatch(setHeaderBackgroundColourRevise(headerTheme)),
        setBackgroundColorRevise: (siderbarTheme) => dispatch(setBackgroundColorRevise(siderbarTheme))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Theme);